import React from 'react'
import styled from 'styled-components'
import { Button as _AntButton } from 'reactstrap'

import { FONTS } from '../../constants'
import { buttonColor } from './color'

export const Button = ({
  theme = '#428BCA',
  bold = false,
  disabled = false,
  style,
  icon,
  width,
  height,
  outline,
  radius,
  children,
  onClick,
}) => {
  return (
    <Root width={ width } height={ height } style={ style }>
      <AntButton
        theme={ theme }
        disabled={ disabled }
        outline={ outline }
        bold={ bold.toString() }
        radius={ radius }
        onClick={ onClick }
      >
        {icon}
        {children}
      </AntButton>
    </Root>
  )
}

const Root = styled.div`
    width: ${p => p.width || 'fit-content'};
    height: ${p => p.height || 'fit-content'};
    border-radius: 4px;

    svg {
        margin-right: 8px;
    }
`

const AntButton = styled(_AntButton)`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${p => {
    if (p.outline) {
      return buttonColor[p.theme].outline.background
    }
    return buttonColor[p.theme].background
  }
};
    border: ${p => {
    if (p.outline) {
      return buttonColor[p.theme].outline.border
    }
    return buttonColor[p.theme].border
  }
};
    color: ${p => {
    if (p.outline) {
      return buttonColor[p.theme].outline.color
    }
    return buttonColor[p.theme].color
  }
};
    border-radius: ${p => p.radius || '4px'};
    font-family: ${p => (p.bold === 'true' ? FONTS.GOTHAM_BOLD : FONTS.GOTHAM)};
    font-size: ${FONTS.SMALL_SIZE};
    padding: 0;

    :hover {
      background: ${p => {
    if (p.outline) {
      return buttonColor[p.theme].outline.hover.background
    }
    return buttonColor[p.theme].hover.background
  }
};
    border: ${p => {
    if (p.outline) {
      return buttonColor[p.theme].outline.hover.border
    }
    return buttonColor[p.theme].hover.border
  }
};
    color: ${p => {
    if (p.outline) {
      return buttonColor[p.theme].outline.hover.color
    }
    return buttonColor[p.theme].hover.color
  }
};
    }

    :focus {
      box-shadow: none;
      outline: none;
    }

    :disabled {
      background: ${buttonColor['disabled'].background};
      border: ${buttonColor['disabled'].border};
      color: ${buttonColor['disabled'].color};
    }
`



// WEBPACK FOOTER //
// ./src/components/buttons/button.js